import { AxiosRequestTransformer } from "axios";
import dayjs from "dayjs";
import { defaultApiDateFormatYYYYMMDD } from "../Utils/dates";

export const transformRequestDatesToApiFormat: AxiosRequestTransformer = (data, headers) => {
  if (
    headers &&
    headers["Content-Type"] !== undefined &&
    headers["Content-Type"] !== "application/json"
  ) {
    return data;
  }

  if (data instanceof Date) {
    return dayjs(data).format(defaultApiDateFormatYYYYMMDD);
  }
  if (Array.isArray(data)) {
    return data.map((value) => transformRequestDatesToApiFormat(value));
  }
  if (data !== null && typeof data === "object") {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [key, transformRequestDatesToApiFormat(value)])
    );
  }
  return data;
};
